var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('Loader'):_c('div',{staticClass:"content"},[_c('Subscription',{attrs:{"customer":_vm.customer_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }